import axios from 'axios';
import { baseUrl, withAuth } from '../auth/helper';

export default {
  getChats: withAuth(async (params, options) => {
    const response = await axios.get(`${baseUrl}/admin/chats`, options)
    return response
  }),
  getRecipients: withAuth(async (params, options) => {
    const response = await axios.get(`${baseUrl}/admin/recipients`, options)
    return response
  }),
  sendMessage: withAuth(async (params, options) => {
    const response = await axios.post(`${baseUrl}/admin/message`, params, options)
    return response
  }),
  getSettings: withAuth(async (params, options) => {
    const response = await axios.get(`${baseUrl}/admin/settings`, options)
    return response
  }),
  updateSettings: withAuth(async (params, options) => {
    const response = await axios.put(`${baseUrl}/admin/settings`, params, options)
    return response
  }),
  getSolutions: withAuth(async (params, options) => {
    const query = params?.onlyPending ? '?filter=pending' : ''
    const response = await axios.get(`${baseUrl}/admin/solutions${query}`, options)
    return response
  }),
  setSolutionApproval: withAuth(async (params, options) => {
    const response = await axios.put(`${baseUrl}/admin/solution/${params.solutionId}/approval`, { approved: params.approved }, options)
    return response
  }),
}
